import type { Terminal } from "server/dwhApi/terminals/types.js";

export const getPotentialRecyclingRate = (d?: Terminal) => {
  if (!d || !d.totalWasteWeight.quantity) return 0;

  const potentialRecycledWeight =
    d.totalWasteWeight.quantity -
    d.totalResidualWasteWeight.quantity +
    d.totalContaminatedWasteWeight.quantity;

  return +(
    (potentialRecycledWeight * 100) /
    d.totalWasteWeight.quantity
  ).toFixed(1);
};
